export default __webpack_public_path__ + "static/media/Group 8622.3583cd41.png";